// Localização: ./src/pages/AIAssistant/AIAssistantPage.jsx
// Página principal do assistente de IA

import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AIProvider } from '../../context/AIContext';
import ChatInterface from '../../components/AIAssistant/ChatInterface';
import ConversationHistory from '../../components/AIAssistant/ConversationHistory';

/**
 * Página do Assistente de IA
 */
const AIAssistantPage = () => {
    const location = useLocation();
    const initialMessage = location.state?.initialMessage || null;
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [selectedConversation, setSelectedConversation] = useState(null);

    const handleSelectConversation = (conversation) => {
        // Definir a conversa selecionada diretamente
        // O ChatInterface vai detectar a mudança pelo session_id
        setSelectedConversation(conversation);
    };

    const handleNewConversation = () => {
        // Limpar o chat e iniciar nova conversa
        setSelectedConversation(null);
        // O clearChat será chamado através do ChatInterface
    };

    const handleConversationLoaded = () => {
        // Não resetar selectedConversation aqui, apenas quando necessário
        // Isso permite que a conversa permaneça carregada
    };

    return (
        <AIProvider>
            <div className="w-full min-w-0 p-3 sm:p-4 md:p-6 lg:p-8">
                <div className="max-w-6xl mx-auto">
                    {/* Card do Chat */}
                    <div className="rounded-xl shadow-lg overflow-hidden !bg-white chat-interface-bg" style={{ height: 'calc(100vh - 200px)', minHeight: '600px', backgroundColor: '#ffffff', background: '#ffffff' }}>
                        <ChatInterface 
                            initialMessage={initialMessage}
                            selectedConversation={selectedConversation}
                            onConversationLoaded={handleConversationLoaded}
                            onNewConversation={handleNewConversation}
                            onOpenHistory={() => setIsHistoryOpen(true)}
                        />
                    </div>
                </div>

                {/* Painel de Histórico */}
                <ConversationHistory
                    isOpen={isHistoryOpen}
                    onClose={() => setIsHistoryOpen(false)}
                    onSelectConversation={handleSelectConversation}
                    onNewConversation={handleNewConversation}
                />
            </div>
        </AIProvider>
    );
};

export default AIAssistantPage;

